import { useQyGetCardCategory } from "@factory/query/card-category.query";
import { LabelValue } from "@shared/models/label-value.interface";
import { Dropdown } from "primereact/dropdown";
import { useState } from "react";

export function useCardCategory() {
  // DECLARATIONS
  const [selectedCard, setSelectedCard] = useState(null);

  // API DEFINITIONS
  const { data: cardCategoryResponse } = useQyGetCardCategory("", 9999, 0);
  const cardCategoryData = cardCategoryResponse?.data || [];
  const cardCategoryOptions = LabelValue.MapArray(
    cardCategoryData,
    (item) => item?.name,
    (item) => item.code
  );

  // LOCAL FUNCTIONS

  // LOCAL RENDERS
  const cardCategoryDropdown = (
    <Dropdown
      value={selectedCard}
      onChange={(e) => setSelectedCard(e.value)}
      options={cardCategoryOptions}
      placeholder="Select a card category"
      className="w-full md:w-14rem"
    />
  );

  return { cardCategoryDropdown, selectedCard, setSelectedCard };
}
